import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "../LandingPage.module.css";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const TermsOfUse = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/privacy-policy');
    window.scrollTo(0, 0);
  };
  const card = [
    {
      description: (
        <>
          We are pleased that you have elected to visit and use this website,
          www.jpcapital.info (the “Website” or the “Site”), operated by, or on
          behalf of JP Capital LLC (“JP CAPITAL” or the “Company”).
          <br />
          <br />
          JP CAPITAL is a market-leading, independent research firm. We are
          experts in U.S. macro and crypto market strategy and have leveraged
          those fundamental insights to become leading pioneers of digital
          assets and blockchain research. We serve a broad array of clients
          around the world, including internationally recognized multitrillion
          dollar asset managers, hedge funds and private banks, representing
          some 80% of globally managed equity assets.
          <br />
          <br />
          The Website offers individual investors the opportunity to subscribe
          to weekly newsletters and research packages which provide data and
          information to help subscribers understand and formulate investment
          strategies (the “Subscription Packages”). The Website also offers its
          registered members market information and related news on the Website
          (collectively, information offered on the Site and Subscription
          Packages are “Services”).
          <br />
          <br />
          Please read these Terms of Use (“Terms of Use”) carefully and ensure
          you understand them. These Terms of Use, including all documents
          referenced herein, represent the entire understanding and agreement
          between JP CAPITAL and you regarding your use of this Website and
          supersede any prior statements or representations. This Website’s
          Privacy Policy is incorporated into these Terms of Use by reference
          and is made a part hereof. You are not authorized to use the Website
          if you do not agree to all or any of these Terms and Conditions.
        </>
      ),
    },
    {
      title: "Changes to the Terms of Use",
      description:
        "From time to time, these Terms of Use may change. JP CAPITAL reserves the right to modify these Terms of Use without prior individual notice. We will post changes to the Terms of Use on this Website and changes will become effective once posted. Your continued access to or use of the Website will be deemed as acceptance by you of the then-current Terms of Use. Please review these Terms of Use often so that you will remain abreast of our current policies. You can tell when the Terms of Use were last modified by checking the “last updated” date that appears at the top.",
    },
    {
      title: "Use of this website",
      description: (
        <>
          This Website is controlled and operated by JP CAPITAL from its office
          in the United Arab Emirates UAE, and is intended for use solely within
          the United States, and its territories and possessions. You must be 18
          years of age to use this Site. JP CAPITAL makes no representation that
          this Website, or the materials contained hereon, are appropriate for
          users located in other countries. Those who choose to access this Site
          from other countries do so on their own initiative and are responsible
          for compliance with all laws in that country, if and to the extent
          that such laws are applicable.
          <br />
          <br />
          Access to, distribution and/or use of this Website is subject to all
          applicable laws and regulations. To the extent that access to,
          distribution and/or use of this Website would be deemed illegal by
          applicable law, such access, distribution and/or use is prohibited.
          Each time you visit any area on the Website and/or register for any
          interactive functionality of the Website, you are deemed to have
          confirmed your acceptance to these Terms of Use and the Website’s
          Privacy Policy. If you do not agree to abide by these Terms of Use and
          the Privacy Policy, please do not use this Website.
          <br />
          <br />
          By participating in the activities offered on this Site, you affirm,
          represent and warrant that: (a) you are 18 years of age or older and
          reside in the United States; (b) all information you submit via the
          Site shall be truthful and accurate (and you will maintain the
          accuracy of such information); (c) you will abide by these Terms of
          Use; and (d) your use of the Website shall not otherwise violate any
          applicable law, rule or regulation.
          <br />
          <br />
          JP CAPITAL may terminate your right to access and/or use this Website
          at any time.
        </>
      ),
    },
    {
      title: "Use of materials",
      description: (
        <>
          Materials on this Website, including but not limited to sound
          recordings, images, reports, trademarks, compilations, and graphics
          (collectively referred to as the “Materials”), are protected under
          various intellectual property laws and owned or controlled by JP
          CAPITAL, or used with permission of the owner(s) of such Materials.
          The display of Materials at this Website does not imply that a license
          of any kind has been granted to you.
          <br />
          <br />
          JP CAPITAL hereby grants you permission to use the Website and the
          Materials as set forth in these Terms of Use, provided that:
          <ul>
            <li>
              your use of the Website and Materials as permitted is solely for
              your personal, noncommercial use;
            </li>
            <li>
              your use of the Website and Materials as permitted is solely for
              your personal, noncommercial use;
            </li>
            <li>
              you will otherwise comply with these Terms of Use and applicable
              laws.
            </li>
          </ul>
          In order to access some features of the Website and subscribe to the
          services and products offered by JP CAPITAL through the Website, you
          may have to create an account. When creating an account, you must
          provide your accurate and complete information and you may not use a
          fake identity or any other individual’s identity.
          <br />
          <br />
          Except as otherwise indicated on this Website, copying, reproducing,
          uploading, downloading, transmitting or any other use of this Website
          or of any of the Material, in whole or part, without the express
          permission of JP CAPITAL, is prohibited. You may download digital
          files where expressly permitted. Any unauthorized access to, use or
          copying of this Website and/or the Materials may subject you to
          liability under applicable law, and may result in legal action.
        </>
      ),
    },
    {
      title: "Privacy",
      description: (
        <>
          Please see 
          <span onClick={handleClick} className={styles.privacyPolicyLink}>
            JP CAPITAL’s Privacy Policy
          </span>
           for information concerning the collection and use of Personal
          Information from this Website.
        </>
      ),
    },
    {
      title: "Availability of Product Offerings",
      description:
        "Not all of the product offerings and/or services referenced on this Website may be available to all individuals accessing this Website. Certain product offerings may not be available in all areas of the United States, and certain individuals may not be eligible for all of the product offerings referenced on this Site. Subject to applicable law, JP CAPITAL retains the right to determine each individual’s eligibility for such products.",
    },
    {
      title: "Financial disclosures",
      description:
        "JP CAPITAL is an independent research company and is not a registered investment advisor and is not acting as a broker dealer under any federal or state securities laws. The research provided in the Subscription Packages and/or on the Website is for the clients of JP CAPITAL only. Information has been obtained from sources believed to be reliable but JP CAPITAL does not want warrant its completeness or accuracy. All pricing is as of the market close for the securities discussed, unless otherwise stated. Opinions and estimates constitute our judgment as of the date of this material and are subject to change without notice. Past performance is not indicative of future results. This material is not intended as an offer or solicitation for the purchase or sale of any financial instrument. The opinions and recommendations herein do not take into account individual client circumstances, risk tolerance, objectives, or needs and are not intended as recommendations of particular securities, financial instruments or strategies. The recipient of any JP CAPITAL generated research and/or report must make his/her own independent decision regarding any securities or financial instruments mentioned herein. Except in circumstances where JP CAPITAL expressly agrees otherwise in writing, JP CAPITAL is not acting as a municipal advisor and the opinions or views contained herein are not intended to be, and do not constitute, advice, including within the meaning of Section 15B of the Securities Act of 1934.",
    },
    {
      title: "Links",
      description:
        "The JP CAPITAL Website may contain links to other websites and to social media features (collectively, “other sites”) that are not controlled and/or maintained by JP CAPITAL. Access to and use of such other websites is at your own risk and subject to any Terms of Use and Privacy Policies which govern other sites. By providing such links, JP CAPITAL shall not be deemed to endorse, recommend, approve, guarantee or introduce any third parties or their services or products, or any facts, views, advice, information, promotions and/or products found on other sites. JP CAPITAL is not responsible for the content contained on other sites, or for the failure of any product or service offered for sale or advertised on any other sites or for any damages that may result therefrom. Copyrights in the materials or information on the linked other sites are owned and/or controlled by other organizations. Moreover, such other sites may have privacy policies or terms of use that differ from those of the JP CAPITAL Website and/or may provide their users with less security than the JP CAPITAL Website. Accordingly, you should review the privacy policies and terms of use on such other sites before using them.",
    },
    {
      title: "Account registration and Password responsibility",
      description: (
        <>
          In order to access and subscribe to and/or purchase the product and
          service offerings on this Website, you will be required to register
          and to create an account and a password. As part of the process for
          creating such an account and password, you will be asked to confirm
          that you have read, consent to, and agree to be bound by the Terms and
          Conditions of use of this Website (including but not limited to its 
            <span onClick={handleClick} className={styles.privacyPolicyLink}>
            Privacy Policy
          </span>
          ).
          <br />
          <br />
          If you are asked to choose a password, you will be responsible for
          maintaining the confidentiality of your password. You agree not to (i)
          use the account, username or password of any other user of the Site at
          any time, (ii) share your account, or (iii) disclose your password to
          any third party. You agree to notify JP CAPITAL immediately if you
          suspect any unauthorized access to or use of your account or password.
          You are solely responsible for any and all use of your account and
          password.
        </>
      ),
    },
    {
      title: "Non-commercial use",
      description:
        "You may not use the Website or any Materials provided herein in connection with any commercial endeavors except those that are specifically endorsed or approved of by JP CAPITAL’s management.",
    },
    {
      title: "Additional/Different terms",
      description:
        "Certain pages or sections of this Website may contain Terms of Use of use which are in addition to or different from these Terms of Use. In the event that there is a conflict between such additional or different Terms of Use and these Terms of Use, the additional or different Terms of Use of use will govern with respect to the specific pages or sections to which they apply.",
    },
    {
      title: "No specific advice Is provided by this website",
      description:
        "This Website is for general informational purposes, and is not intended to provide specific legal, accounting, tax, investment or other professional advice to any specific user. You should consult with appropriate legal advisors or other professionals with respect to your investment, retirement, and/or related financial decisions.",
    },
    {
      title: "Subscriptions",
      description: (
        <>
          JP CAPITAL currently offers two free subscription packages to choose
          from: the “JP CAPITAL Newsletter” package and the “JP CAPITAL Update”
          package. Investors subscribe on an ongoing basis. Subscribers to both
          options may need to select the unsubscribe option at the bottom of an
          email from each list in order to be removed entirely from our
          distribution lists. Cancellations of all subscriptions can be made by
          selecting this link to send an email to 
          <span className={styles.privacyPolicyMail}>
            Update@jpcapital.info
          </span>
          .<br />
          <br />
          JP CAPITAL may unilaterally terminate a subscription for reasons
          unrelated to any improper conduct by subscriber, including but not
          limited to breach of these Terms of Use.
        </>
      ),
    },
    {
      title: "Cancelation of Account/Subscription",
      description:
        "JP CAPITAL may terminate or suspend your Account, your Subscription Package and/or your access to the Services at any time, for any reason, and without advance notice. If we do so, it’s important to understand that you don’t have a contractual or legal right to continue to use our Services. JP CAPITAL may refuse service to anyone, at any time, for any reason. If we terminate or suspend your Account or refuse service for any improper conduct, which shall be determined in JP CAPITAL’s sole and subjective discretion, you will not be entitled to any refund of your monthly or annual subscription payment.",
    },
    {
      title: "Limitation of liability and user disclaimer",
      description: (
        <>
          JP CAPITAL endeavors to make sure that all information and data it
          originates on the Website is accurate. However, JP CAPITAL is not
          responsible for any damages or loss related to the use of this Website
          or the products and/or services provided through the Website.
          <br />
          <br />
          THIS WEBSITE, ALL MATERIAL CONTAINED ON THIS WEBSITE, AND ALL LINKS OR
          OTHER ITEMS RELATED THERETO ARE TRANSMITTED AND DISTRIBUTED “AS IS”
          AND TO THE FULLEST EXTENT PERMITTED AT LAW WITHOUT GUARANTEES,
          REPRESENTATIONS, WARRANTIES AND/OR CONDITIONS OF ANY KIND, EITHER
          EXPRESS OR IMPLIED (BY STATUTE OR OTHERWISE), INCLUDING, WITHOUT
          LIMITATION, THAT THE WEBSITE AND/OR ITS FEATURES AND FUNCTIONS WILL BE
          AVAILABLE FOR USE OR WORK AS DESCRIBED. THERE ARE NO GUARANTEES,
          REPRESENTATIONS, WARRANTIES AND/OR CONDITIONS REGARDING TITLE,
          SECURITY, ACCURACY, ACCEPTABLE QUALITY, MERCHANTABILITY OR FITNESS FOR
          A PARTICULAR PURPOSE OR USE WITH RESPECT TO THE WEBSITE OR THE
          MATERIALS CONTAINED HEREON. ANY INFORMATION CONTAINED WITHIN OR ON
          THIS WEBSITE IS SUBJECT TO AMENDMENT, REVISION OR UPDATING. JP CAPITAL
          RESERVES THE RIGHT TO SUSPEND OR WITHDRAW ACCESS TO THE PAGES OF THIS
          WEBSITE WITHOUT NOTICE AT ANY TIME AND TO THE FULLEST EXTENT PERMITTED
          AT LAW, ACCEPTS NO RESPONSIBILITY FOR THESE PAGES NOT BEING AVAILABLE
          AT ALL TIMES.
          <br />
          <br />
          UNLESS PROHIBITED BY LAW, NEITHER JP CAPITAL (INCLUDING ITS OFFICERS,
          DIRECTORS, AGENTS AND EMPLOYEES), NOR ANY PARTY INVOLVED IN CREATING,
          PRODUCING OR DELIVERING THIS SITE, SHALL BE LIABLE FOR ANY ALLEGED
          DAMAGE OR INJURY WHATSOEVER, INCLUDING BUT NOT LIMITED TO ANY
          COMPENSATORY, PUNITIVE, EXEMPLARY, INCIDENTAL, CONSEQUENTIAL, DIRECT,
          INDIRECT, SPECIAL AND/OR ANY OTHER DAMAGES THAT RESULT FROM YOUR USE
          OR INABILITY TO USE OR ACCESS THIS WEBSITE OR FROM ANY MATERIALS
          CONTAINED HEREON OR FROM ANY COMPUTER VIRUS, MALFUNCTION OR OTHER
          FAILURE. SOME JURISDICTIONS PROHIBIT THE EXCLUSION OR LIMITATION OF
          LIABILITY FOR CERTAIN TYPES OF DAMAGES, IN WHICH CASE THE ABOVE
          LIMITATION MAY NOT APPLY TO YOU.
          <br />
          <br />
          TO THE FULLEST EXTENT PERMITTED BY LAW, JP CAPITAL MAKES NO
          GUARANTEES, WARRANTIES,REPRESENTATIONS OR CONDITIONS ABOUT THE
          ACCURACY OR SUITABILITY FOR ANY PURPOSE OF THE SITE’S CONTENT OR THE
          CONTENT OF ANY SITES LINKED TO THIS SITE AND TO THE FULLEST EXTENT
          PERMITTED BY LAW ASSUMES NO LIABILITY OR RESPONSIBILITY FOR (I)
          MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR PROPERTY
          DAMAGE OF ANY NATURE WHATSOEVER FROM ACCESS TO, REPRODUCTION,
          DISTRIBUTION AND/OR USE OF THIS WEBSITE, (III) ANY UNAUTHORIZED ACCESS
          TO, REPRODUCTION, DISTRIBUTION OR USE OF JP CAPITAL’S SECURE SERVER
          AND/OR ANY PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
          THEREON, (IV) ANY INTERRUPTION OF OR CESSATION OF THE SITE, (V) ANY
          BUGS, VIRUSES, TROJAN HORSES OR THE LIKE WHICH MAY BE TRANSMITTED VIA
          THE SITE AND/OR BY ANY THIRD PARTY, AND/OR (VI) ANY ERRORS OR
          OMISSIONS IN ANY CONTENT OR ANY LOSS OF TRANSMITTED INFORMATION OR
          DATA, OR DAMAGE THAT IS THE RESULT OF THE USE OF ANY CONTENT POSTED,
          EMAILED, TRANSMITTED OR OTHERWISE MADE AVAILABLE BY OR THROUGH THE
          WEBSITE.
          <br />
          <br />
          JP CAPITAL is not responsible for any damages or loss related to your
          reliance on any outdated version of these Terms of Use, including, but
          not limited, to any outdated version of our 
          <span onClick={handleClick} className={styles.privacyPolicyLink}>
            Privacy Policy
          </span>
          .
        </>
      ),
    },
    {
      title: "Your responsibilities",
      description:
        "You are responsible for undertaking suitable precautions to scan for computer viruses and maintaining a backup of all data and/or equipment. By having clicked your acceptance of these Terms of Use and/or using this Website, you agree that you will be responsible for maintaining the confidentiality of your password and account information, and that you will restrict access to your computer to avoid disclosure of such. You further agree that you will be responsible for all activity taken under your password and/or account.",
    },
    {
      title: "Indemnity",
      description:
        "Unless prohibited by law, you will indemnify JP CAPITAL, and each of its parent, subsidiary and affiliated entities, furnishing entities, officers, directors, members, employees, representatives, licensees, agents, successors, assignees and partners, from and against any and all claims, demands, losses, liabilities, damages, costs and expenses (including but not limited to attorneys’ fees) suffered, incurred or brought against any one or more of them by a third party relating to, or arising from or in connection with: (i) your breach or alleged breach of any of your representations and/or warranties set forth in these Terms of Use; (ii) your use of the Website; and/or (iii) any violation of these Terms of Use. You agree that your representations and warranties, and your obligation to indemnify JP CAPITAL, shall survive beyond any term for which these Terms of Use are in effect.",
    },
    {
      title: "Electronic communications",
      description: (
        <>
          When you communicate with JP CAPITAL electronically, via email or
          otherwise, you consent to receive electronic communications from JP
          CAPITAL. 
          <span onClick={handleClick} className={styles.privacyPolicyLink}>
            You may opt out of receiving electronic communications from JP
            CAPITAL at any time
          </span>
          . You agree that all communications (including, but not limited to all
          notices, agreements and disclosures) provided to you electronically by
          JP CAPITAL satisfy any legal requirement that such communication be in
          writing. JP CAPITAL encourages you to retain your own copies of
          relevant information, however, upon your written request, JP CAPITAL
          will provide you with a copy of the information you provided to JP
          CAPITAL when creating your account. To make such a request please
          contact 
          <span className={styles.privacyPolicyMail}>
            Update@JPCAPITAL.info
          </span>
          .<br />
          <br />
          With respect to all communications you make to or through the Website,
          including but not limited to feedback, questions, comments,
          suggestions and the like: (i) you shall have no right to
          confidentiality in your communications and JP CAPITAL shall have no
          obligation to protect your communications from disclosure; (ii) JP
          CAPITAL shall be free to reproduce, use, publish, display, disclose
          and distribute your communications to others without limitation ; and
          (iii) JP CAPITAL shall be free to use any ideas, concepts, know-how,
          information, data content or techniques contained in your
          communications for any purpose whatsoever, including but not limited
          to the development, production and marketing of products and services
          that incorporate such information.
        </>
      ),
    },
    {
      title: "Acquisition of business",
      description:
        "In the event that JP CAPITAL and/or any of its affiliated entities is involved in a merger, acquisition, consolidation, restructuring, reorganization, liquidation, sale or similar transaction relating to any portion of its business and/or assets, you hereby acknowledge and agree that this Website, all data collected on this Website, and all rights of JP CAPITAL and its affiliated entities hereunder may be included in the assets of, and/or transferred pursuant to, such transaction. If that occurs, JP CAPITAL will post a notice to such effect on this Website.",
    },
    {
      title: "Contact us",
      description: (
        <>
          If you have any questions concerning this Website or any of the
          policies set forth in these Terms of Use, please contact us at:
          <br />
          JP CAPITAL LLC
          <br />
          Sharjah Media City, UAE
          <br />
          Email: 
          <span className={styles.privacyPolicyMail}>
            Update@JPCAPITAL.info
          </span>
        </>
      ),
    },
    {
      title: "Copyright infringement – notice and take-down policy",
      description: (
        <>
          JP CAPITAL values intellectual property and respects the intellectual
          property rights of others, and will remove materials on its Website
          that infringe the copyrights of others. If you believe that your
          copyrighted material has been infringed by material contained on this
          Website, you should provide the following notice to JP CAPITAL:
          <br />
          Address: JP CAPITAL LLC
          <br />
          Sharjah Media CIty
          <br />
          UAE 515000
          <br />
          Electronic Mail Address: 
          <span className={styles.privacyPolicyMail}>
            Update@JPCAPITAL.INFO
          </span>
          <br />
          <br />
          In your notice, you must include the following:
          <ul>
            <li>
              a physical or electronic signature of the owner of an exclusive
              right that is being infringed or of a person authorized to act on
              behalf of such owner;
            </li>
            <li>
              identification of the copyrighted work(s) that is (are) allegedly
              being infringed;
            </li>
            <li>
              identification of the materials that are causing the infringement
              and that are to be removed, along with sufficient information to
              allow JP CAPITAL to locate such materials;
            </li>
            <li>
              contact information (i.e., name, address, email address)
              sufficient to enable JP CAPITAL to contact you;
            </li>
            <li>
              a statement to the effect that you have a good faith belief that
              the complained of use of the material was not authorized by the
              owner of the copyright, its agent or the law; and
            </li>
            <li>
              a statement that the information in the notification is accurate,
              and under penalty of perjury, that the complaining party is
              authorized to act on behalf of the owner of the exclusive right
              that is allegedly being infringed.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: "U.S. Export Controls",
      description:
        "Software and the products obtained through or related to this Website may be subject to United States export controls or the export controls of other countries from where you access the Site. No software or products may be downloaded from the Website or otherwise exported or reexported in violation of U.S. or other countries’ export laws, as applicable. Downloading or using the software or products is at your sole risk.",
    },
    {
      title: "Disputes and Governing Law",
      description: (
        <>
          Use of this Website and these Terms of Use shall be governed by the
          laws of the State of New York of the United States of America, without
          regard to its conflict of law provisions. In the event that any
          portion of these Terms of Use are deemed unenforceable, unlawful or
          void by a tribunal of competent jurisdiction, in any jurisdiction for
          any reason, unless narrowed by construction, such portion of these
          Terms of Use shall, for purposes of such jurisdiction only, be
          construed as if such invalid, prohibited or unenforceable portion had
          been more narrowly constructed so as not to be invalid, prohibited or
          unenforceable (or if such provision cannot be drawn narrowly enough,
          the tribunal making any such determination shall have the power to
          modify such portion of these Terms of Use to the extent necessary to
          make such portion of these Terms of Use enforceable in such
          jurisdiction, and such portion shall then be applicable in such
          modified form in such jurisdiction). If, notwithstanding the
          foregoing, any such portion of these Terms of Use would be held to be
          invalid, prohibited or unenforceable in any jurisdiction for any
          reason, such portion, as to such jurisdiction only, shall be
          ineffective to the extent of such invalidity, prohibition or
          unenforceability, without invalidating the remaining provisions set
          forth in these Terms of Use. No narrowed construction, modification or
          invalidation of any portion of the Terms of Use shall affect the
          construction, validity or enforceability of such portion in any other
          jurisdiction. No waiver by JP CAPITAL of any term or condition of
          these Terms of Use shall be deemed a further or continuing waiver of
          such term or condition or of any other term or condition, and JP
          CAPITAL’s failure to assert any right or demand compliance with any
          provision of these Terms of Use shall not be deemed to constitute a
          waiver of any such right or provision.
          <br />
          <br />
          Except where prohibited by law, as a condition of you clicking
          acceptance of these Terms of Use and/or accessing and/or using this
          Website, you agree that (1) any and all disputes and causes of action
          arising out of or connected with this Website shall be resolved
          individually, without resort to any form of class action, and
          exclusively by final and binding arbitration in New York within one
          year from the date that the cause of action arose (or, if multiple
          cause of actions are involved, from the date that the first cause of
          action arose), with such arbitration conducted pursuant to the then
          prevailing rules of the American Arbitration Association; and (2)
          judgment upon such arbitration award may be entered in any court
          having jurisdiction. To the fullest extent permitted by law, no
          arbitration brought pursuant hereto shall be joined to any other
          action or arbitration.
          <br />
          <br />
          The rules governing arbitration are different than those in court.
          Arbitration does not involve a judge or jury and review is limited,
          but an arbitrator can award the same damages as a court. You
          understand that by accepting these Terms and Conditions, you are
          giving up your right to a trial in court, either with or without a
          jury.
          <br />
          <br />
          To the fullest extent permitted at law, under no circumstances will
          you be permitted to obtain an award for, and by accessing and/or using
          the site you waive all rights to claim, punitive, incidental,
          consequential or any other damages (including multiplied and/or
          increased damages and/or attorneys’ fees and court costs) for, any
          dispute or cause of action that you may have that relates in whole or
          part to this Website and/or the Materials. Notwithstanding anything to
          the contrary set forth in these Terms of Use or otherwise, your
          recovery with respect to any and all claims, judgments, and awards for
          which you are entitled shall, to the fullest extent permitted at law,
          be limited to your actual out-of-pocket costs incurred, excluding
          attorneys’ fees and court costs.
          <br />
          <br />
          Notwithstanding anything to the contrary set forth in these Terms of
          Use, JP CAPITAL may at any time seek injunctive or other appropriate
          relief against you and/or against others, in any state or federal
          court in the state of New York and/or in any other court chosen by JP
          CAPITAL, in the event that JP CAPITAL believes that there is a
          violation, or a threatened violation, of any of JP CAPITAL’s
          intellectual property rights and, in such case, you hereby consent to
          the exclusive jurisdiction and venue of such court.
        </>
      ),
    },
  ];
  return (
    <Grid container justifyContent="center">
      <Grid
        size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7 }}
        className={styles.contactContainer}
      >
        <Grid container rowSpacing={2}>
          <Grid size={12} className={styles.centerItem}>
            <Typography className={styles.aboutUsTitle}>
              WEBSITE TERMS & CONDITIONS
            </Typography>
          </Grid>
          <Grid size={12} className={styles.centerItem}>
            <Typography className={styles.aboutUsHeading}>
              JP Capital LLC Terms of Use
            </Typography>
          </Grid>
          {card.map((data, index) => {
            return (
              <Grid key={index}>
                <Grid container rowSpacing={2}>
                  <Grid>
                    <Typography className={styles.aboutUsTitle}>
                      {data.title}
                    </Typography>
                  </Grid>
                  <Grid size={12}>
                    <Typography className={styles.aboutUsDescription}>
                      {data.description}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TermsOfUse;
